// th.js 泰语配置文件
export default {
    'messages': {
      'tips': 'รหัสแท็กขาดหายหรือไม่ถูกต้อง กรุณาสแกน QR Code อีกครั้ง',
      'title':'MegaC Pet Tag',
      'slog':'เริ่มสร้างแท็กสัตว์เลี้ยงส่วนตัวของคุณ',
      'public_data':'ข้อมูลสาธารณะ',
      'data_tips':'ข้อมูลนี้จะปรากฏเมื่อสแกนแท็ก QR',
      'pet_name':'ชื่อสัตว์เลี้ยง',
      'pet_name_tips':'กรุณากรอกชื่อสัตว์เลี้ยง',
      'birthday':'วันเกิด',
      'birthday_tips':'เลือกวันเกิดสัตว์เลี้ยง',
      'weight':'น้ำหนัก',
      'weight_tips':'กรุณากรอกน้ำหนักสัตว์เลี้ยง',
      'phone':'เบอร์โทร',
      'phone_tips':'กรุณากรอกเบอร์โทรเจ้าของสัตว์เลี้ยง',
      'email':'อีเมล',
      'email_tips':'กรุณากรอกอีเมลเจ้าของสัตว์เลี้ยง',
      'note':'หมายเหตุ',
      'note_tips':'กรุณาเขียนบางอย่างเพื่อแนะนำสุนัขของคุณ',
      'modify_key':'คีย์แก้ไข',
      'modify_key_tips':"คีย์นี้ใช้สำหรับแก้ไขข้อมูลสาธารณะ คุณสามารถกรอกอะไรก็ได้ แต่ต้องจำไว้ หากไม่เช่นนั้นคุณจะไม่สามารถแก้ไขข้อมูลสาธารณะได้",
      'modify_key_ruler':'กรุณากรอกคีย์แก้ไข',
      'modify_info':'แก้ไขข้อมูลสัตว์เลี้ยง',
      'submit':'ส่ง',
      'birthday_select':'เลือกวันเกิด',
      'ok':'ตกลง',
      'cancel':'ยกเลิก',
      'call_onwer':'โทรหาเจ้าของ',
      'send_email':'ส่งอีเมล',
      'contact_info':'ข้อมูลติดต่อ',
      'key_error':'คีย์แก้ไขไม่ถูกต้อง',
      'loading':'กำลังโหลด...',
      'submitting':'กำลังส่ง...',
      'select_crop_area':'กรุณาเลือกพื้นที่ตัด',
      'uploading_image':'กำลังอัปโหลดรูปภาพ...',
      'upload_failed':'อัปโหลดล้มเหลว กรุณาลองใหม่',
      'upload_success':'อัปโหลดรูปภาพสำเร็จ',
      'image_process_failed':'ประมวลผลรูปภาพล้มเหลว',
      'save_success':'บันทึกสำเร็จ!',
      'save_failed':'บันทึกล้มเหลว กรุณาลองใหม่',
      'verify_success':'ยืนยันสำเร็จ',
    }
  }
